module.exports = __webpack_public_path__ + "4dfb01ca0a92e7944371a02c98a8fc1c.svg";